module.exports = __webpack_public_path__ + "media/images/gift-teaser-53c7892ed5c0a9b5e231a1b9ffa23b87.jpg";